import moment from 'moment';
import RosterItem from './RosterItem';
import RosterBooking from './RosterBooking';
import RosterSummarizedBooking from './RosterSummarizedBooking';

export default class RosterItemWithSummarizedBookings extends RosterItem {
  constructor(type, start, end, hasActuals) {
    super(type, start, end, hasActuals);
    this.summarizedBookings = [];
  }

  allHaveActuals() {
    return (
      super.allHaveActuals() &&
      this.summarizedBookings.every((summarizedBooking) =>
        summarizedBooking.allHaveActuals()
      )
    );
  }

  mustAddToSummarizedBooking(booking) {
    return true;
  }

  sort() {
    this.summarizedBookings.sort((b1, b2) => b1.start - b2.start);
    this.summarizedBookings.forEach((booking) => booking.sort());
  }

  addBooking(booking) {
    // Adding a booking to the shift consists of two steps: 1) splitting of the parts of the booking that are not overlapping with the shift, and 2) adding the overlapping part to a summarized booking inside of the shift

    // Step 1: Split up the booking based on the start/end of the shift and prepare the remaining pieces
    // These are returned at the end of the method and recursively processed in the DayRosters object
    const remainder = [];
    const bookingStart = booking.start;
    const bookingEnd = booking.end;
    const shiftStart = this.start;
    const shiftEnd = this.end;
    if (bookingStart.isBefore(shiftStart)) {
      remainder.push(
        new RosterBooking(
          bookingStart,
          shiftStart,
          booking.hasActuals,
          booking.fullBookingStart,
          booking.fullBookingEnd,
          booking.booking
        )
      );
    }
    if (bookingEnd.isAfter(shiftEnd)) {
      remainder.push(
        new RosterBooking(
          shiftEnd,
          bookingEnd,
          booking.hasActuals,
          booking.fullBookingStart,
          booking.fullBookingEnd,
          booking.booking
        )
      );
    }

    // Set the times of the booking to align with those of the shift
    booking.start = moment.max(bookingStart, shiftStart);
    booking.end = moment.min(bookingEnd, shiftEnd);

    // Step 2: Look for a summarized booking which the booking overlaps with
    // If none such summarized booking exists, we create a new one and add it
    // If it does, we need to add it to this summarized booking
    if (this.mustAddToSummarizedBooking(booking)) {
      let toProcess = [booking];
      while (toProcess.length > 0) {
        const singleBooking = toProcess[0];
        const overlappingSummmarizedBooking = this.summarizedBookings.find(
          (summarizedBooking) => summarizedBooking.overlapsWith(singleBooking)
        );
        if (overlappingSummmarizedBooking) {
          // When adding the booking to the summarizedBooking we get returned the parts that didn't overlap, so we need to keep processing them until the entire booking is consumed
          // This call is given a callback as a second argument that can be used to add new summarized bookings if needed (they might need to be split up too)
          toProcess = overlappingSummmarizedBooking.addBooking(
            singleBooking,
            (summarizedBooking) => this.summarizedBookings.push(summarizedBooking)
          );
        } else {
          // No overlapping booking so we just create a new one
          const summarizedBooking = new RosterSummarizedBooking(
            [singleBooking],
            singleBooking.start,
            singleBooking.end
          );
          toProcess = [];
          this.summarizedBookings.push(summarizedBooking);
        }
      }
    }

    return remainder;
  }
}
